import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const defaultState = () => ({
    labelBloqueo: '',
    boletas: [],
    porTipApo: [],
    imprimir: {
        tipo_aporte: '',
        tipo_frm: 1,
        nro_afi_listado: []
    },
    conceptosTotal: [],
    conceptosNoVencidos: [],
    conceptosVencidos: [],
    conceptosBloqueados: [],
    conceptosDebitoAuto: [],
    deudaGroup: [],
    mescuota: '',
    anioconv: '',
    hayOrdenPagoActiva: false,
    selectorDetalleAp: [],
    boletasDisponibles: [],
    pagosRealizados: [],
    isLoading: false,
    loadingDeuda: false,
    resumenAportes: [],
    ordenPago: {},
    ordenPagoActiva: {},
    cancelarOrdenPago: [],
    url: "",
    mensajeError: '',
    mensajeNoPuedePagar: '',
});

export default ({
    namespaced: true,

    state: defaultState(),
    getters: {
        labelBloqueo(state) {
            return state.labelBloqueo
        },
        mensajeError(state) {
            return state.mensajeError
        },
        mensajeNoPuedePagar(state) {
            return state.mensajeNoPuedePagar
        },
        isLoading(state) {
            return state.isLoading
        },
        hayOrdenPagoActiva(state) {
            return state.hayOrdenPagoActiva
        },
        url(state) {
            return state.url
        },
        orderMercadoPago(state) {
            return state.orderMercadoPago
        },
        ordenPago(state) {
            return state.ordenPago
        },
        ordenPagoActiva(state) {
            return state.ordenPagoActiva
        },
        actualizarOrdenPago(state) {
            return state.actualizarOrdenPago
        },
        porTipApo(state) {
            return state.porTipApo
        },
        boletas(state) {
            return state.boletas
        },
        mescuota(state) {
            return state.mescuota
        },
        boletasDisponibles(state) {
            return state.boletasDisponibles
        },
        resumenAportes(state) {
            return state.resumenAportes
        },
        hayOrdenPagoActiva(state) {
            return state.hayOrdenPagoActiva
        },
        loadingDeuda(state) {
            return state.loadingDeuda
        },

        // conceptos para pagos
        conceptosTotal(state) {
            return state.conceptosTotal
        },

        conceptosNoVencidos(state) {
            return state.conceptosNoVencidos
        },
        conceptosVencidos(state) {
            return state.conceptosVencidos
        },
        conceptosDebitoAuto(state) {
            return state.conceptosDebitoAuto
        },
        conceptosBloqueados(state) {
            return state.conceptosBloqueados
        },
        hayConceptosNoVencidos(state) {
            return (state.conceptosNoVencidos.length !== 0)
        },
        deudaGroup(state) {
            return state.deudaGroup
        },
        selectorDetalleAp(state) {
            return state.selectorDetalleAp
        },
        pagosRealizados(state) {
            return state.pagosRealizados
        }
    },
    mutations: {
        RESET_STATE(state) {
            Object.assign(state, defaultState());
        },
        setConsultarPagos(state, payload) {
            state.pagosRealizados = payload
        },
        setSelectorDetalle(state, payload) {
            state.selectorDetalleAp = payload
        },
        setConceptosNoVencidos(state, payload) {
            state.conceptosNoVencidos = payload
        },
        setConceptosVencidos(state, payload) {
            state.conceptosVencidos = payload
        },
        setConceptosDebitoAuto(state, payload) {
            state.conceptosDebitoAuto = payload
        },
        setConceptosBloqueados(state, payload) {
            state.labelBloqueo = payload.length > 0 ? payload[0].pmp_observaciones : ''
            state.conceptosBloqueados = payload
        },
        setBoletasDisponibles(state, payload) {
            state.boletasDisponibles = payload
        },
        setResumenAportes(state, payload) {
            state.resumenAportes = payload
        },
        setOrder(state, payload) {
            if (payload && typeof payload === 'object' && (
                (Array.isArray(payload) && payload.length > 0) ||
                (!Array.isArray(payload) && Object.keys(payload).length > 0)
            )) {
                state.ordenPagoActiva = payload
                state.url = payload.mmp_url
                state.hayOrdenPagoActiva = true
            } else {
                state.ordenPagoActiva = {}
                state.ordenPago = {}
                state.hayOrdenPagoActiva = false
                state.url = ''
            }
        },
        setNewOrder(state, payload) {
            if (payload && typeof payload === 'object' && (
                (Array.isArray(payload) && payload.length > 0) ||
                (!Array.isArray(payload) && Object.keys(payload).length > 0)
            )) {
                state.ordenPago = payload
                //  url -> payload.sandbox_init_point 
                state.url = payload.init_point
            } else {
                state.ordenPago = null
                state.url = ''
            }
        },
        setOrdenPagoActiva(state, payload) {
            state.ordenPagoActiva = payload
        },
        setOrdenActiva(state, payload) {
            state.hayOrdenPagoActiva = payload
        },
        setCancelarPago(state, payload) {
            state.actualizarOrdenPago = payload
        },
        setLoading(state, payload) {
            state.isLoading = payload
        },
        setTotalConceptos(state, payload) {
            state.conceptosTotal = payload
        },
        setLoadingDeuda(state, payload) {
            state.loadingDeuda = payload
        },
        setCargaConceptos(state, payload) {
            state.cargaConceptos = payload
        },
        setMensajeError(state, payload) {
            state.mensajeError = payload
        },
        setMensajeNoPuedePagar(state, payload) {
            state.mensajeNoPuedePagar = payload
        },
    },
    actions: {
        resetModulo({ commit }) {
            commit('RESET_STATE');
        },
        clearConceptos({ commit }) {
            commit('setTotalConceptos', []);
            commit('setConceptosDebitoAuto', []);
            commit('setConceptosNoVencidos', []);
            commit('setConceptosVencidos', []);
            commit('setConceptosBloqueados', []);
        },

        async getConsultarPagos({ commit, dispatch }, payload) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_MERCADOPAGO_API + 'mercadopago/consultaPago/afiliado',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                const res = response.data
                commit('setConsultarPagos', res.pagos)
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },

        //no lo uso
        async getBoletasDisponibles({ commit, dispatch }) {
            await axios({
                method: 'post',
                //url: process.env.VUE_APP_API + 'portal/boletas/' + this.getters['auth/nroafi'],
                url: process.env.VUE_APP_API + 'portal/boletas',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                const res = response.data.boletasDisponibles
                commit('setBoletasDisponibles', res)
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })

            })
        },
        async getDetalleAfiliado({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/aportes/detalle',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                const res = response.data.aportesPagos
                commit('setSelectorDetalle', res)
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },
        async getResumenAportes({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/aportes/' + sessionStorage.getItem('nroafi'),
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                const res = response.data.aportesPagos
                commit('setResumenAportes', res)
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })

            })
        },
        async getConceptos({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/aportes/deuda',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                if (response.data.success) {
                    const conceptosDebitoAuto = response.data.deuda.filter(item => item.pmp_observaciones !== "" && item.pmp_esdeuda !== 1)
                    const conceptosNoVencidos = response.data.deuda.filter(item => item.pmp_esdeuda == 0 && item.pmp_observaciones == "")
                    const conceptosVencidos = response.data.deuda.filter(item => item.pmp_esdeuda == 1 && item.pmp_observaciones == "")
                    const conceptosBloqueados = response.data.deuda.filter(item => item.pmp_esdeuda == 1 && item.pmp_observaciones.includes("plan de pagos"))
                    commit('setTotalConceptos', response.data.deuda)
                    commit('setConceptosDebitoAuto', conceptosDebitoAuto)
                    commit('setConceptosNoVencidos', conceptosNoVencidos)
                    commit('setConceptosVencidos', conceptosVencidos)
                    commit('setConceptosBloqueados', conceptosBloqueados)
                } else {
                    commit('setMensajeNoPuedePagar', response.data.mensaje)
                    commit('setTotalConceptos', [])
                    commit('setConceptosDebitoAuto', [])
                    commit('setConceptosNoVencidos', [])
                    commit('setConceptosVencidos', [])
                    commit('setConceptosBloqueados', [])
                }

            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
                commit('setLoadingDeuda', false)
            })
        },

        /* Ejemplo de success */
        ////payment_id, payment_type, status en ActualizarOrdenPago

        //type=SUCCESS
        //ref=YToyOntpOjA7aTo3OTEzOTtpOjE7aToxMTU5NDt9
        //nroafi=200

        //&collection_id=88690622917
        //collection_status=approved&payment_id=88690622917&status=approved&external_reference=YToyOntpOjA7aTo3OTEzOTtpOjE7aToxMTU5NDt9&payment_type=debit_card&merchant_order_id=23268180937&preference_id=1941014527-90bfd971-b744-4a74-abfa-f66dcf36afea&site_id=MLA&processing_mode=aggregator&merchant_account_id=null


        // genera orden de pago
        async generarOrder({ commit, dispatch, rootGetters }, data) {
            if (rootGetters['auth/esModoGestion']) {
                dispatch('notificaciones/showSnack', {
                    message: 'Operación no permitida en modo gestión.',
                    type: '400',
                }, { root: true });
                return false;
            }
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_MERCADOPAGO_API + 'mercadopago/crearOrdenPago',
                    withCredentials: false,
                    data: JSON.stringify(data),
                });
                const res = response.data.ordenPago;
                if (!res.success) {
                    dispatch('notificaciones/showSnack', {
                        message: res.msg,
                        type: '400',
                    }, { root: true });
                    return false;
                } else {
                    commit('setNewOrder', res);
                    return true;
                }
            } catch (error) {
                dispatch('notificaciones/showSnack', {
                    message: 'ERROR: No se pudo generar la orden de pago.',
                    type: '400',
                }, { root: true });
                return false;
            } finally {
                dispatch('auth/setSktLoader', false, { root: true });
            }
        },
        async getCargaConceptos({ commit, dispatch }, data) {
            commit('setCargaConceptos', data)
        },
        /*
        Antes 
        const obj = {
            "nroafi":200,
            "id":5,
            "estado": "B" // estado B = baja, P = pago
            }
        **/
        //POST->ordenPago/actualizarOrdenPago { 'nroafi' => 'required|int',  'external_reference' => 'required', "estado": "B" // estado B = baja, P = pago}
        //POST->ordenPago/actualizarOrdenPago { 'nroafi' => 'required|int',  'ref' => 'required', "type": "B" // estado B = baja, P = pago}
        async actualizarOrdenPago({ commit, dispatch, rootGetters }, data) {
            if (rootGetters['auth/esModoGestion']) {
                dispatch('notificaciones/showSnack', {
                    message: 'Operación no permitida en modo gestión.',
                    type: '400',
                }, { root: true });
                return false;
            }
            await axios({
                method: 'post',
                url: process.env.VUE_APP_MERCADOPAGO_API + 'mercadopago/ordenPago/actualizarOrdenPago',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(data),
            }).then((response) => {
                const res = response.data
                // commit('setOrder', []) 
                commit('setOrder', data)
            }).catch(function (error) {
                console.log(error)
            })
        },

        /*   async eliminarOrdenPago({ commit, dispatch }, data) {
              await axios({
                  method: 'delete',
                  url: process.env.VUE_APP_MERCADOPAGO_API + '/ordenPago/cancelarOrdenPago',
                  withCredentials: false,
                  data: JSON.stringify(data),
                  headers: {
                      "Content-Type": "application/json",
                  }
              }).then((response) => {
                  commit('setOrder', [])
              }).catch(function (error) {
                  console.log(error)
                  dispatch('notificaciones/showSnack', {
                      message: response.data.error,
                      type: '400',
                  }, { root: true })
              })
          }, */
        //DELETE->ordenPago/eliminarOrdenPago { 'nroafi' => 'required|int',  'external_ref' => 'required|int'}
        async caducarOrdenPago({ commit, dispatch, state, rootGetters }) {
            if (rootGetters['auth/esModoGestion']) {
                dispatch('notificaciones/showSnack', {
                    message: 'Operación no permitida en modo gestión.',
                    type: '400',
                }, { root: true });
                return false;
            }
            await axios({
                method: 'post',
                url: process.env.VUE_APP_MERCADOPAGO_API + 'mercadopago/ordenPago/cancelarOrdenPago',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({ nroafi: sessionStorage.getItem('nroafi'), preferenceId: state.ordenPago.id }),
            }).then((response) => {
                const res = response.data
                return true
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: response.data.error,
                    type: '400',
                }, { root: true })
                return false
            })
        },
        async consultarOrdenActiva({ commit, dispatch }) {
            commit('setLoadingDeuda', true)
            await axios({
                method: 'post',
                url: process.env.VUE_APP_MERCADOPAGO_API + 'mercadopago/ordenPago/consultarOrdenActiva',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                const res = response.data
                commit('setOrdenActiva', false)
                dispatch('getConceptos')
            }).catch(function (error) {
                const errorMsg = error.response.data.error;
                commit('setMensajeError', errorMsg)
                commit('setOrdenActiva', true)
            })
        },
        //imprimir PDF en boletas
        imprimirPdf({ commit, dispatch }, data) {
            data.token = sessionStorage.getItem('token');
            var url = process.env.VUE_APP_BOLETAS;

            // Crear un iframe oculto para evitar abrir ventanas
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.name = 'pdf_download_frame_' + Date.now(); // Nombre único
            document.body.appendChild(iframe);

            // Crear el formulario que apunta al iframe
            var form = document.createElement("form");
            form.action = url;
            form.method = 'POST';
            form.target = iframe.name; // Apunta al iframe por su nombre

            for (var key in data) {
                var input = document.createElement("textarea");
                input.name = key;
                input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
                form.appendChild(input);
            }
            form.style.display = 'none';
            document.body.appendChild(form);
            form.submit();

            // Limpiar después de 10 segundos (tiempo suficiente para que se descargue)
            setTimeout(() => {
                if (form.parentNode) {
                    document.body.removeChild(form);
                }
                if (iframe.parentNode) {
                    document.body.removeChild(iframe);
                }
            }, 10000);

            // Notificación opcional
            dispatch('notificaciones/showSnack', {
                message: 'Descargando boleta...',
                type: '200',
            }, { root: true });
        },
        //imprimir PDF en boletas
        /* imprimirPdf({ commit, dispatch }, data) {
            data.token = sessionStorage.getItem('token')
            var url = process.env.VUE_APP_BOLETAS
            var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
            var l = Math.floor(Math.random() * 100);
            var t = Math.floor(Math.random() * 100);
            // var url = process.env.VUE_APP_BOLETAS

            var form = document.createElement("form");
            form.action = url;
            form.method = 'POST';
            form.target = id;
            for (var key in data) {
                var input = document.createElement("textarea");
                input.name = key;
                input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
                form.appendChild(input);
            }
            form.style.display = 'none';
            document.body.appendChild(form);
            //window.open('', id, 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,status=no,left=' + l + ',top=' + t);
            form.submit();
        }, */
        //imprimir PDF detalle
        imprimirPdfDetalle({ commit, dispatch }, data) {
            var url = process.env.VUE_APP_APORTES
            var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
            var l = Math.floor(Math.random() * 100);
            var t = Math.floor(Math.random() * 100);
            // var url = process.env.VUE_APP_BOLETAS

            var form = document.createElement("form");
            form.action = url;
            form.method = 'POST';
            form.target = id;
            for (var key in data) {
                var input = document.createElement("textarea");
                input.name = key;
                input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
                form.appendChild(input);
            }
            form.style.display = 'none';
            document.body.appendChild(form);
            //window.open('', id, 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,status=no,left=' + l + ',top=' + t);
            form.submit();
        },
        /*         imprimirPdfDetalle({ commit, dispatch }, data) {
                    var url = process.env.VUE_APP_APORTES
                    var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
                    var l = Math.floor(Math.random() * 100);
                    var t = Math.floor(Math.random() * 100);
                    // var url = process.env.VUE_APP_BOLETAS
        
                    var form = document.createElement("form");
                    form.action = url;
                    form.method = 'POST';
                    form.target = id;
                    for (var key in data) {
                        var input = document.createElement("textarea");
                        input.name = key;
                        input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
                        form.appendChild(input);
                    }
                    form.style.display = 'none';
                    document.body.appendChild(form);
                    //window.open('', id, 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,status=no,left=' + l + ',top=' + t);
                    form.submit();
                }, */


        //imprimir PDF en boletas
        descargarPericia({ commit, dispatch }, data) {
            var url = process.env.VUE_APP_PERICIAS
            var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
            var l = Math.floor(Math.random() * 100);
            var t = Math.floor(Math.random() * 100);

            var form = document.createElement("form");
            form.action = url;
            form.method = 'POST';
            form.target = id;
            form.value = "5"


            for (var key in data) {
                var input = document.createElement("textarea");
                input.name = key;
                input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
                form.appendChild(input);
            }
            form.style.display = 'none';
            document.body.appendChild(form);


            //no mustra la ventana
            //window.open('', id, 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,status=no,left=' + l + ',top=' + t);
            console.log(form)
            form.submit();
        },

    },
})